import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AuthActions, AuthConfigService, AuthService, ClientToken, FeatureToggles, getLastValueSync, OCC_USER_ID_ANONYMOUS, OCC_USER_ID_CURRENT } from '@spartacus/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomAuthService extends AuthService {
  http: HttpClient = inject(HttpClient);
  authConfigService: AuthConfigService = inject(AuthConfigService);
  newFeatureToggles = inject(FeatureToggles);
  /**
   * Loads a new user token with Resource Owner Password Flow.
   * @param userId
   * @param password
   */
  async loginWithCredentialsWithoutRedirect(userId: string, password: string): Promise<void> {
    let uid = userId;

    if (this.authMultisiteIsolationService) {
      uid = await this.authMultisiteIsolationService.decorateUserId(uid).toPromise();
    }

    try {
      await this.oAuthLibWrapperService.authorizeWithPasswordFlow(uid, password);

      // OCC specific user id handling. Customize when implementing different backend
      this.userIdService.setUserId(OCC_USER_ID_CURRENT);

      this.store.dispatch(new AuthActions.Login());
    } catch {}
  }

  public override refreshAuthConfig() {
    if (!!this.newFeatureToggles.authorizationCodeFlowByDefault && this.isAsmEnabled()) {
      const asmClientID: string = environment?.oAuthClient?.asmClient?.clientID ?? '';
      this.oAuthLibWrapperService.changeAuthConfigClientId(asmClientID);
      this.updateIsUsingASMClient(true);
    } else {
      this.oAuthLibWrapperService.refreshAuthConfig();
      this.updateIsUsingASMClient(false);
    }
  }

  public loadClientAuthenticationToken(): Observable<ClientToken> {
    const userId = getLastValueSync(this.userIdService.getUserId());
    const isAnonymousUser = userId === OCC_USER_ID_ANONYMOUS;
    const clientID: string = isAnonymousUser
      ? environment.oAuthClient.generalClient?.client_id
      : environment.oAuthClient.trustClient?.client_id;
    const clientSecret: string = isAnonymousUser
      ? environment.oAuthClient.generalClient?.client_secret
      : environment.oAuthClient.trustClient?.client_secret;
    const url: string = this.authConfigService.getTokenEndpoint();
    const params = new HttpParams()
      .set('client_id', encodeURIComponent(clientID))
      .set('client_secret', encodeURIComponent(clientSecret))
      .set('grant_type', 'client_credentials');

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    return this.http.post<ClientToken>(url, params, { headers });
  }
}
